import { AppContext } from '../Context';
import { Fragment, useEffect, useContext, useState, useRef } from 'react';

import axios from 'axios';

//plugins
import InfinityEncryptor from '../plugins/InfinityEncryptor';

const nonstate = {
    dbScriptFileMap: {
        "fetchAppBuild": "appControl.php", //NetworkVersionController
        "checkServerStatus": "appControl.php", //AppController
        "fetchOtpBypassCode": "appControl.php", //OtpScreen
        "resendEmailVerification": "mailControl.php", //OtpScreen

        "fetchEmailByMemberID_Nric": "accountControl.php", //Login
        "checkMemberExistByEmail": "accountControl.php", //Login
        "fetchActiveMembershipsByEmail": "accountControl.php", // Login
        "fetchAllMembershipsByEmail": "accountControl.php", // Login
        "fetchFinalContractByMembershipIDs": "accountControl.php", //Login
        "updatePasswordPinNumberBy_userID": "accountControl.php", //Login
        "sendEmailVerification": "mailControl.php", // /Login, ManageMembership
        "resendEmailVerificationCode": "mailControl.php", //Login, ManageMembership
        "fetchMemberByUserIDPassword": "accountControl.php", // /Login
        "setEmailVerifiedByUserID": "accountControl.php", //Login

        "loginMember": "accountControl.php", // /Login
        "loginCommitteeViaEmailPassword": "accountControl.php", // /Login
        "fetchMemberByMemberIDEmailPassword": "accountControl.php", // /Login
        "checkUserNotActivated": "accountControl.php", //Login
        "resetPassword": "accountControl.php", //Login
        "fetchUnActivatedMembershipsByEmail" : "accountControl.php", //Login

        "fetchCommitteeTypes" : "accountControl.php", //WatchSyncController
        "fetchEventCategories" : "eventControl.php", //WatchSyncController
        "fetchMemberTypes": "accountControl.php", //WatchSyncController
        "fetchMemberFees": "accountControl.php", //WatchSyncController
        "fetchInvoiceNotes": "accountControl.php", //WatchSyncController
        "fetchDocumentCategories": "documentControl.php", //WatchSyncController
        "fetchAssociatedBroadcasts": "appControl.php", //WatchSyncController
        "fetchMembershipRegistration": "registrationControl.php", //WatchSyncController
        "fetchMembership": "accountControl.php", //WatchSyncController
        "fetchMembershipUsers": "accountControl.php", //WatchSyncController //ManageMembership
        "fetchMembershipContracts": "registrationControl.php", //WatchSyncController
        // "fetchOngoingEvents": "eventControl.php", //WatchSyncController --deprecate, move to Events
        "fetchUserEventRegistrations": "registrationControl.php", //WatchSyncController
        // "fetchUserEvents": "eventControl.php", //WatchSyncController ---deprecated, renamed to fetchUserUpcomingEvents
        "fetchUserUpcomingEvents": "eventControl.php", //WatchSyncController
        "fetchViewableDocuments": "documentControl.php", //WatchSyncController
        "fetchAllDocuments": "documentControl.php", //WatchSyncController
        // "fetchAllEvents": "eventControl.php", //WatchSyncController ---attempt deprecated
        "fetchAllCommitteeMembers": "accountControl.php", //WatchSyncController
        "fetchMeetingInvitations": "eventControl.php", //WatchSyncController
        "fetchAcceptedUpcomingMeetings": "eventControl.php", //WatchSyncController
        // "fetchUnvotedUpcomingPolls": "pollControl.php", //WatchSyncController ---deprecated to fetch unvotedCurrentAndVotedPolls
        "fetchUnvotedCurrentAndVotedPolls": "pollControl.php", //WatchSyncController
        "fetchHostedMeetings": "eventControl.php", //WatchSyncController & ViewMeetings
        "fetchHostedMeetingInvitations": "eventControl.php", //WatchSyncController
        "fetchHostedMeetingAttachments": "eventItemControl.php", //WatchSyncController
        "fetchHostedPolls": "pollControl.php", //WatchSyncController
        "fetchOngoingEvents": "eventControl.php", //WatchSyncController
        "updateMemberUser": "accountControl.php", //WatchSyncController
        "loginSuccess": "accountControl.php", //WatchSyncController
        "logoutSuccess": "accountControl.php", //WatchSyncController
        // "fetchMembershipById" : "accountControl.php", //WatchSyncController ---deprecated
        // "fetchEventsByIDs": "eventControl.php", //WatchSyncController, only committee memberUser ---deprecated of unused
        // "fetchCommitteeMembers": "accountControl.php", //WatchSyncController, only committee memberUser ---deprecated to fetchAllCommitteeMembers
 
        "deleteMemberUserByID": "accountControl.php", //ManageMembership
        "checkEmailExist" : "accountControl.php", //ManageMembership
        "checkHandphoneNoExist": "accountControl.php", //ManageMembership
        "checkMembershipUserExist": "accountControl.php", //ManageMembership
        "createMemberUser": "accountControl.php", //ManageMembership
        "updateMember": "accountControl.php", //WatchSyncController
        "updateMemberUserByEdit": "accountControl.php", // /ManageMembership
        "createMembershipRenewalOrder": "registrationControl.php", //ManageMembership
        "fetchPayments": "paymentControl.php", //ManageMembership, header
        // "fetchPaymentInvoice": "paymentControl.php", //ManageMembership & Events & EventRegistrations ---deprecated to invoiceControl.php to generatePdf
        "sendCreateMembershipUserNotification": "mailControl.php", //ManageMembership

        "fetchUpcomingEvents": "eventControl.php", //MemberHome, Events 
        "fetchLatestPastEvents": "eventControl.php",//MemberHome
        "fetchCurrentNewsletters": "documentControl.php",//MemberHome

        "fetchPastEventsByBatch": "eventControl.php", //Events
        // "fetchSecondaryMemberUsersOfEvent": "accountControl.php", // /Events
        // "fetchMemberUsersOfEvent": "accountControl.php", //Events MyEvents, Move To WatchSyncController
        // "createEventRegistration": "registrationControl.php", // /Events ---deprecated to createEventRegistrationOrder
        // "fetchEventRegisteredParticipantsByMemberID": "registrationControl.php", //Events ---deprecated
        "fetchEventRegistrationsByEvent_MemberID": "registrationControl.php", //Event
        "createEventRegistrationOrder": "registrationControl.php", //Events
        "uploadMemberNric": "registrationControl.php", //Events
        "uploadMemberPassport": "registrationControl.php", //Events
        "uploadPublicNric": "registrationControl.php", //Events
        "uploadPublicPassport": "registrationControl.php", //Events
        "updatePaymentComplete": "paymentControl.php", // /Events
        "generateEventRegistrationReferrals": "registrationControl.php", // /Events
        "fetchEventFee_eventID_memberTypeID": "eventControl.php", //Events
        "fetchEventRegistrationsByID": "registrationControl.php", //Events

        "fetchRegRefID": "eventControl.php", // /MyEvents
        "fetchEventRegistrationReferrals": "eventControl.php", //MyEvents
        "fetchEventByID": "eventControl.php", // MyEvents, Events
        "fetchUserUpcomingEventRegistrations": "registrationControl.php", //MyEvents
        "fetchUserPastEventRegistrations": "registrationControl.php", //MyEvents
        "fetchEventAttachmentsByEventID": "eventItemControl.php", //MyEvents

        "fetchMemberEventRegistrations": "registrationControl.php", //EventRegistrations
        "fetchEventRegistrationPaymentsByRegistrationIDs": "registrationControl.php", //EventRegistrations
        "fetchRegistrationEventsByRegistrationIDs": "registrationControl.php", //EventRegistration
        "fetchParticipantInfoByUserIDs": "registrationControl.php", // EventRegistration

        "fetchOngoingAndPastEventsByBatch": "eventControl.php", //ViewEventGallery
        //"fetchEventGalleryByEventID": "eventControl.php", ---deprecated //ViewEventGallery
        "fetchEventItemByEventIDAndType" : "eventControl.php", //ViewEventGallery, ManageEventAttachments, MyEvents
        "uploadEventPhoto": "eventControl.php", //ViewEventGallery
        "updateEventItemFileNames": "eventControl.php", //ViewEventGallery, //ManageEventAttachments
        "deleteEventItem": "eventControl.php", //ViewEventGallery
        "fetchEventsByCategory": "eventControl.php", //ViewEventGallery, //ManageEventAttachments
        "injectEventItem": "eventItemControl.php", //ViewEventGallery
        "fetchEventsStartDateByCategory": "eventControl.php",//ViewEventGallery
        "fetchEventsByCategoryAndYear": "eventControl.php", //ViewEventGallery
        "fetchLast10Events": "eventControl.php", //ViewEventGallery

        "uploadEventAttachment": "eventControl.php", //ManageEventAttachments

        "updateUserPassword": "accountControl.php", // /ChangePassword

        "updateUserPinNumber": "accountControl.php",//ResetPin

        // "fetchPasswordHash": "accountControl.php", //SecondaryAccount ---deprecated
        // "fetchSecondaryMemberUsers": "accountControl.php", // /SecondaryAccount ---deprecated to WatchSyncController fetchMembershipUsers
        // "deleteMemberUserByID": "accountControl.php", //SecondaryAccount ---deprecated to ManageMembership

        "fetchECertSignatures": "appControl.php", //ECert ecert generation
        "fetchHighlightProfiles": "../assets/highlights/index.php", //MemberHome

        "fetchImage": "appControl.php", //ImagePreviewer

        "createUpdateMeeting": "eventControl.php", //ViewMeetings
        "sendMeetingInvitationNotification": "mailControl.php",//ViewMeetings
        "sendMeetingInvitationPushNotification": "appControl.php", //ViewMeetings
        "updateMeetingInvitationStatus": "eventControl.php", //ViewMeetings
        "uploadAttachment": "eventControl.php", //ViewMeetings
        "checkAndRemoveAttachments": "eventItemControl.php", //ViewMeetings
        "deleteMeeting": "eventControl.php", //ViewMeetings
        "fetchMeetingsByEventIDs":"eventControl.php", //ViewMeetings
        "fetchMeetingAttachmentsByEventIDs":"eventItemControl.php", //ViewMeetings
        "fetchViewableMeetingAttachmentsByEventIDs" : "eventItemControl.php", //ViewMeetings

        "fetchOngoingPolls": "pollControl.php", //ViewPolls
        "updatePollVotes": "pollControl.php", //ViewPolls
        "createPoll": "pollControl.php", //ViewPolls
        "uploadPollOption": "pollControl.php", //ViewPolls
        "deletePoll": "pollControl.php", //ViewPolls

        "fetchMembersList": "accountControl.php", //MembersList

        "fetchViewableDocumentsByCategoryID": "documentControl.php", //ViewDocuments
        "createDocument": "documentControl.php", //ViewDocuments
        "deleteDocument": "documentControl.php", //ViewDocuments
        "updateDocumentByID": "documentControl.php", //ViewDocuments
        "checkDocumentExist": "documentControl.php", //ViewDocuments

        "fetchAllBroadcasts": "broadcastControl.php", //ManageNotifications
        "createBroadcast": "broadcastControl.php", //ManageNotifications
        "updateBroadcast": "broadcastControl.php", //ManageNotifications
        "deleteBroadcast": "broadcastControl.php", //ManageNotifications

        "registerDevicePushToken":"appControl.php", //NotificationsController
    }
}

interface Props {
    databaseActionModeQueueRef: any, databaseActionModeQueue: string[], SetDatabaseActionModeQueue: any,
    databaseActionParamsQueueRef: any, databaseActionParamsQueue: any[], SetDatabaseActionParamsQueue: any,
    databaseResultAction: any, SetDatabaseResultAction: any,
    databaseShouldShowWaitScreen: boolean
}

const DatabaseRequestController: React.FC<Props> = ({
        databaseActionModeQueueRef, databaseActionModeQueue, SetDatabaseActionModeQueue,
        databaseActionParamsQueueRef, databaseActionParamsQueue, SetDatabaseActionParamsQueue,
        databaseResultAction, SetDatabaseResultAction, databaseShouldShowWaitScreen
    }) => {
    //context
    const appContext = useContext(AppContext);
    //controllers
    const iencryptor = new InfinityEncryptor('22499', 'MYDIH');

    //lifecycle
    useEffect(() => {
        //FetchSponsorsFromServer();
    }, []);

    //watch for database action commands queue process update
    useEffect(() => {
        if(
            databaseActionModeQueue.length > 0 &&
            databaseActionParamsQueue.length > 0 &&
            databaseActionModeQueue.length == databaseActionParamsQueue.length &&
            databaseResultAction == null
        ) {
            SetDatabaseResultAction(() => DatabaseResultAction);
        }
    }, [databaseActionModeQueue, databaseActionParamsQueue, databaseResultAction]);

    //test
    // useEffect(() => {
    //     console.log('DatabaseControllerTest:\n ' + JSON.stringify(databaseActionModeQueue) + '\n\n' + JSON.stringify(databaseActionParamsQueue));
    // }, [databaseActionModeQueue, databaseActionParamsQueue]);

    //exe function
    const DatabaseResultAction = async () => {
        //unqueue first databaseActionMode & databaseActionParams
        //unqueue databaseActionParams index = 0

        const formData = new FormData();
        formData.append('s3cr3t', iencryptor.Encrypt(appContext.secret));

        const _databaseActionParams = databaseActionParamsQueueRef.current.length > 0 ? databaseActionParamsQueueRef.current.shift() : [];

        _databaseActionParams.map((param: any) => {
            const encryption = (param.length == 3 ? param[2] : true); //default encryption to true if not set 
            if(encryption)
                formData.append(param[0], iencryptor.Encrypt(EscapeQuotes(param[1])));
            else
                formData.append(param[0], 'NOENCRYPT' + EscapeQuotes(param[1]));
        });

        if(databaseShouldShowWaitScreen) {
            appContext.SetWaitScreenMessage('please wait');
            appContext.SetWaitScreenShouldShow(true);
        }

        // ResetDatabaseRequest(); --deprecated, actionMode and actionParams should auto unqueue itself now

        //unqueue databaseActionMode 
        const _databaseActionMode = databaseActionModeQueueRef.current.shift();
        //update state to complete the unqueueProcess
        SetDatabaseActionModeQueue([...databaseActionModeQueueRef.current]);
        SetDatabaseActionParamsQueue([...databaseActionParamsQueueRef.current]);

        // console.log('checkDatabaseActionMode: ' + _databaseActionMode);

        const fileUrl = nonstate.dbScriptFileMap[_databaseActionMode as keyof typeof nonstate.dbScriptFileMap];
        
        if(fileUrl != undefined) {
            return await axios.post(appContext.dburl + fileUrl, formData, { withCredentials: false })
            .then((res) => {
                if(databaseShouldShowWaitScreen)
                    appContext.SetWaitScreenShouldShow(false);

                let resData = {} as any;
                if(!JSON.stringify(res.data).includes('NOENCRYPT;')) {
                    try {
                        resData = JSON.parse(iencryptor.Decrypt(res.data)) as any;
                    } catch {
                        resData = iencryptor.Decrypt(res.data) as any; //it's a string
                    }
                } else {
                    try {
                        resData = JSON.parse(res.data.replace('NOENCRYPT;', '')) as any;
                    } catch {
                        resData = res.data.replace('NOENCRYPT;', '') as any; //it's a string
                    }
                }

                requestAnimationFrame(() => {
                    SetDatabaseResultAction(null);
                });
                return [resData, _databaseActionMode];
            }).catch((err) => {
                if(databaseShouldShowWaitScreen)
                    appContext.SetWaitScreenShouldShow(false);

                requestAnimationFrame(() => {
                    SetDatabaseResultAction(null);
                });
                return ['databaseResultActionErr _false ' + err, _databaseActionMode];
            });
        } else {
            requestAnimationFrame(() => {
                SetDatabaseResultAction(null);
            });
            return ['', _databaseActionMode];
        }
    }

    const EscapeQuotes = (subject: any) => {
        try {
            return subject.replace(/(['"\\])/g, '\\$1');
        } catch(e: any) {
            try {
                return subject.toString().replace(/(['"\\])/g, '\\$1');
            } catch {
                return '';
            }
        }
    }
    return (<Fragment />);
}
export default DatabaseRequestController;